<template>
    <div id="submissions"
         class="home-submissions">

        <h3>Moderating channels:</h3>

        <el-row :gutter="30" style="text-align: center">
            <el-col :span="6" v-for="channel in channels" :key="channel.id">
                <el-card class="box-card"
                         shadow="hover"
                         @click.native="handleSelect('/c/'+channel.name)">
                    <h2 class="community_chanel">{{ channel.title }}</h2>
                    <p class="custom-text-lite">{{ channel.description }}</p>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "ModeratorDashboard",

        data() {
            return {
                channels: [
                ]
            };
        },

        methods: {
            handleSelect(item) {
                this.$router.push({path: item})
            },

            getChannels() {
                axios.get('/moderator/channels').then((response) => {
                    this.channels = response.data.data
                })
            },
        },

        mounted() {
            this.getChannels();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/moderators/Dashboard.vue